module.exports = __webpack_public_path__ + "img/Menu.8a25e7e6.png";